import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import ProtectedRoute from './components/Router/ProtectedRoute';
import { cookieUtils } from './components/API/ApiService';
import SignerForm from './components/DemoForm/SignerForm';
import { Toaster } from 'react-hot-toast';
import PublicSignerForm from './components/PublicDemo/PublicSignerForm';
import SuccessPage from './components/Success/SuccessPage';


const AppContent = () => {
  const navigate = useNavigate();
  
  const handleLogout = () => {
    cookieUtils.delete();
    localStorage.clear();
    sessionStorage.clear();
    navigate('/login', { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Routes>
        <Route 
          path="/login" 
          element={
            cookieUtils.get('token') 
              ? <Navigate to="/dashboard/app-keys" replace /> 
              : <Login />
          } 
        />
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute>
              <Dashboard onLogout={handleLogout} />
            </ProtectedRoute>
          }
        />
        <Route 
          path="/" 
          element={<Navigate to="/dashboard/app-keys" replace />} 
        />
        <Route 
          path="/publicdemo" 
          element={<PublicSignerForm />} 
        />
        <Route 
          path="/success" 
          element={<SuccessPage />} 
        />
        <Route 
          path="/demorequest/:requestId" 
          element={<SignerForm />} 
        />
      </Routes>
    </div>
  );
};

// Main App component with Router
const App = () => {
  return (
    <Router>
      <Toaster position="top-right" />
      <AppContent />
    </Router>
  );
};

export default App;